/**
 * iOS standalone PWA keyboard handling. When the soft keyboard opens, the
 * `visualViewport` shrinks but the layout viewport doesn't — fixed-position
 * bottom tabs end up wedged between the keyboard and the field. We toggle
 * `data-keyboard-open` on <html> so CSS can hide the bottom tab bar
 * (rule lives in src/index.css).
 */
export function installKeyboardWatcher(): () => void {
  if (typeof window === 'undefined' || !window.visualViewport) {
    return () => undefined;
  }

  const vv = window.visualViewport;
  const root = document.documentElement;

  const update = () => {
    // 150 px is the empirical threshold between a normal viewport and a
    // viewport that's been compressed by the keyboard on iOS. Web docs say
    // there's no canonical heuristic — this is what most production PWAs ship.
    const compressed = vv.height < window.innerHeight - 150;
    root.dataset.keyboardOpen = compressed ? 'true' : 'false';
  };

  vv.addEventListener('resize', update);
  vv.addEventListener('scroll', update);
  update();

  return () => {
    vv.removeEventListener('resize', update);
    vv.removeEventListener('scroll', update);
    delete root.dataset.keyboardOpen;
  };
}
